import Vue from 'vue'
import Vuex from 'vuex'
import { Base64 } from 'js-base64'

Vue.use(Vuex)

type LoginInfoParam = { vuid: number; account: string; token: string }

const vdbuserinfo = window.localStorage.getItem('vdbuserinfo')
let userInfo = {
  vuid: -2,
  account: '',
  token: ''
}
if (vdbuserinfo) {
  try {
    userInfo = JSON.parse(Base64.decode(vdbuserinfo))
  } catch (e) {
    // nothing
  }
}
export default {
  namespaced: true,
  state: {
    ...userInfo
  },
  mutations: {
    save(state: any, { vuid, account, token }: LoginInfoParam) {
      state.vuid = vuid
      state.account = account
      state.token = token
    }
  },
  actions: {
    saveLoginInfo({ commit }: any, { vuid, account, token }: LoginInfoParam) {
      const param = {
        vuid,
        account,
        token
      }
      commit('save', param)
      window.localStorage.setItem(
        'vdbuserinfo',
        Base64.encode(JSON.stringify(param))
      )
    }
  }
}
